import React from "react";
import { FormattedMessage } from "react-intl";

export default [
    {
        name: "name",
        label: <FormattedMessage id="client.name" />,
        type: "string",
    },
    {
        name: "organizationType",
        label: <FormattedMessage id="organization-form.type" />,
        type: "string",
    },
    {
        name: "commercialRegisterName",
        label: <FormattedMessage id="client.commercialRegisterName" />,
        type: "string",
    },
    {
        name: "website",
        label: <FormattedMessage id="client.website" />,
        type: "string",
    },
    {
        name: "industry",
        label: <FormattedMessage id="client.industry" />,
        type: "string",
    },
    {
        name: "headquarter",
        label: <FormattedMessage id="client.headquarter" />,
        type: "string",
    },
    {
        name: "distributionChannelIds",
        label: <FormattedMessage id="client.distributionChannels" />,
        type: "list",
        url: "/distribution-channels",
        filterValue: "slug",
        entityName: "distributionChannels",
        include: true,
    },
    {
        name: "startDate",
        label: <FormattedMessage id="client.startDate" />,
        type: "date",
    },
    {
        name: "inactiveDate",
        label: <FormattedMessage id="client.inactiveDate" />,
        type: "date",
    },
    {
        name: "shouldNotify",
        label: "Notify client by email",
        type: "checkbox",
    },
    {
        name: "createdAt",
        label: "Joined At",
        type: "date",
    },
];
